import React from 'react';

import { find, get, map } from 'lodash';

import { TopBarSelect } from 'pages/Teachers/shared';

const renderValue = (student) => get(student, 'name');
const buildOptions = (students) =>
  map(students, (student) => ({
    value: student,
    label: student.name
  }));

const StudentSelect = ({ students, selectedStudent, setSelectedStudent }) => {
  const student = find(students, { id: get(selectedStudent, 'id') });

  if (!student) {
    return null;
  }

  return (
    <TopBarSelect
      value={student}
      renderValue={renderValue}
      onChange={setSelectedStudent}
      options={buildOptions(students)}
    />
  );
};

export default React.memo(StudentSelect);
